import helpers from '@/router/helpers';
import UserRoles from '@/constants/user/roles';

export default {
    path: '/inventory/partnership',
    meta: {
        title: 'Partner Ship',
        documentTitle: 'Partner Ship',
        requiresAuth: true,
        mdiIcon: '',
        shouldPersistBetweenLogins: true,
        allowedRoles: [
            UserRoles.SUPER_ADMIN,
            UserRoles.INVENTORY_OPERATOR,
            UserRoles.INVENTORY_ADMINISTRATOR,
        ],
    },
    component: helpers.getRouterView(),
    children: [
        {
            path: '',
            name: 'InventoryPartnerShip',
            meta: {
                title: 'Inventory Partner Ship',
                documentTitle: 'Inventory Partner Ship',
                allowedRoles: [
                    UserRoles.SUPER_ADMIN,
                    UserRoles.INVENTORY_OPERATOR,
                    UserRoles.INVENTORY_ADMINISTRATOR,
                ],
            },
            component: () => import( /* webpackChunkName: "InventoryPartnerShip" */ '@/views/inventory/PartnerShip' ),
        },
    ],
};
